@if (data(); as msg) {
    Added <room-item [room]="msg.room" />
}
 